import { Navigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { enqueueSnackbar } from "notistack";
import { getStoredToken } from "@core/index";
import LoginForm from "../components/LoginForm";
import SecureAccessBadge from "../components/SecureAccessBadge";
import AppLogo from "@shared/components/branding/AppLogo";

const LoginPage = () => {
  const [searchParams] = useSearchParams();
  const token = getStoredToken();

  useEffect(() => {
    if (searchParams.get("session_expired") === "true") {
      enqueueSnackbar("Your session has expired. Please log in again.", {
        variant: "error",
        autoHideDuration: 8000,
      });
      // Clean up the URL
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }, [searchParams]);

  if (token) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      <AppLogo size="large" variant="login" />
      <LoginForm />
      <SecureAccessBadge />
    </>
  );
};

export default LoginPage;
